import { isRouteErrorResponse, useRouteError } from "react-router-dom";

/**
 * Router-level error boundary. Catches errors thrown while rendering a route
 * (loaders, render errors) and shows a minimal, themed fallback rather than a
 * blank screen.
 */
export function RootErrorBoundary() {
  const error = useRouteError();

  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  if (isNotFound) {
    return (
      <div role="alert" style={{ padding: "clamp(16px, 3vw, 32px)" }}>
        <h2 style={{ margin: 0 }}>Page not found</h2>
        <p style={{ color: "var(--text-muted)" }}>
          This page doesn&rsquo;t exist. Use the sidebar to navigate.
        </p>
      </div>
    );
  }

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "Something went wrong.";

  return (
    <div role="alert" style={{ padding: "clamp(16px, 3vw, 32px)" }}>
      <h2 style={{ margin: 0 }}>Something went wrong</h2>
      <p style={{ color: "var(--text-muted)" }}>{message}</p>
    </div>
  );
}
